import React, { useState, useEffect } from "react";
import AdminDashboardLayout from "../../components/layout/AdminDashboardLayout";
import AuditProperty from "../../dashboard/agent-dashboard/AuditProperty";
import Layout from "../../components/layout/Layout";

const AuditPropertyMain = () => {
  const [navParams, setNavParams] = useState({
    navTitle: "Audit Property",
    navSubTitle: "Welcome to Easy Property Dashboard",
  });

  useEffect(() => { }, []);
  return (
    // <Layout hideFooter={true}>
    <AdminDashboardLayout
      navTitle={navParams.navTitle}
      navSubTitle={navParams.navSubTitle}
    >
      <AuditProperty />
    </AdminDashboardLayout>
    // </Layout>
  );
};

export default AuditPropertyMain;
